import services from "../services";
//import * as types from "./mutation-type";

export const ActionUpdateAccount = async ({_}, payload) => {
    return new Promise(async(resolve, reject) => {
        const { data } = await services.updateAccount(payload)
        if(data.error === false) {
            resolve(data)
        }
        reject(data)
    })
}